{
  "_meta": {
    "_comment": "Phase 14.1 Wave 9 Task 46 — merchant pricing namespace (LiveCostCalculator breakdown, rush toggle, service picker, packing-group summary, price error copy). Money rendered via Money/formatUsd, values from API. vg-binding: P14.1.D-04 / P14.1.D-19 / INTERFACE-STANDARDS:error-shape",
    "locale": "vi"
  },
  "breakdown": {
    "title": "Chi tiết chi phí",
    "subtotal": "Tạm tính",
    "productTotal": "Sản phẩm",
    "embroideryFee": "Phí thêu",
    "rushFee": "Phí gấp",
    "shippingFee": "Vận chuyển",
    "tax": "Thuế",
    "tariff": "Thuế quan",
    "discount": "Giảm giá",
    "total": "Tổng cộng",
    "estimatedTotal": "Tổng ước tính",
    "perItem": "Mỗi sản phẩm",
    "empty": "Thêm sản phẩm để xem chi tiết chi phí."
  },
  "rush": {
    "toggleLabel": "Sản xuất gấp",
    "toggleHint": "Ưu tiên đơn này để sản xuất nhanh hơn. Phí gấp áp dụng theo từng sản phẩm.",
    "badge": "Gấp",
    "unavailable": "Không hỗ trợ sản xuất gấp cho điểm đến này."
  },
  "service": {
    "pickerLabel": "Phương thức vận chuyển",
    "pickerPlaceholder": "Chọn phương thức vận chuyển",
    "estimatedDelivery": "Dự kiến giao {{window}}"
  },
  "packingGroups": {
    "title": "Nhóm vận chuyển",
    "groupLabel": "Nhóm {{index}}",
    "itemsCount": "{{count}} sản phẩm",
    "shippingPerGroup": "Phí vận chuyển cho nhóm này",
    "consolidatedHint": "Các sản phẩm giao cùng nhau tính một phí vận chuyển cho mỗi nhóm."
  },
  "errors": {
    "productPriceMissing": "Chưa có bảng giá cho một hoặc nhiều sản phẩm.",
    "shippingFeeMissing": "Chưa cấu hình phí vận chuyển cho dịch vụ và điểm đến đã chọn.",
    "priceDrift": "Giá đã thay đổi so với báo giá. Vui lòng xem lại tổng tiền mới trước khi xác nhận.",
    "embPaymentNotPending": "Phí thêu này không còn ở trạng thái chờ thanh toán. Vui lòng tải lại và thử lại.",
    "embFeeQuoteMismatch": "Phí thêu đã thay đổi. Vui lòng xem lại phí mới trước khi chấp nhận.",
    "walletInsufficient": "Số dư ví của bạn không đủ. Vui lòng nạp thêm và thử lại.",
    "rushFeeZoneMissing": "Không thể sản xuất gấp cho một hoặc nhiều sản phẩm đến điểm đến này.",
    "generic": "Không thể tính giá. Vui lòng thử lại hoặc liên hệ hỗ trợ."
  },
  "status": {
    "calculating": "Đang tính…",
    "recalculated": "Đã cập nhật giá"
  }
}
